export default "__VITE_ASSET__Bf$el_YD__"